import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../components/Loader';
import { fetchCompany, updateCompanyProperties } from '../actions';
import { selectCompany, selectNewCompany } from '../selectors';
import { CompanyEditInner } from './editInner';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const STATE = {
  step: 1,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyEditComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
    if (!this.props.match.params.step) {
      this.to(`/companies/${this.props.company_id}/edit/${this.state.step}`);
    }
    this.setState({ step: +this.props.match.params.step });
  }

  componentDidUpdate(prevState) {
    if (this.state.step === this.lastStep) {
      this.to(`/companies/${this.props.company_id}`);
    }
    prevState.step !== this.state.step ? this.to(`/companies/${this.props.company_id}/edit/${this.state.step}`) : null;
  }

  get lastStep() {
    let step = 4;
    if (env.clientId === AppClientId.INDEWAL) {
      step = 5;
    }
    return step;
  }

  nextStep() {
    this.setState(prevState => ({
      step: prevState.step + 1,
    }));
  }

  prevStep() {
    this.setState(prevState => ({
      step: prevState.step - 1,
    }));
  }

  render() {
    if (!this.props.company) return <Loader small />;
    return (
      <CompanyEditInner
        nextStep={this.nextStep.bind(this)}
        prevStep={this.prevStep.bind(this)}
        step={+this.props.match.params.step}
        company_id={this.props.company_id}
        company={this.props.company}
      />
    );
  }
}

CompanyEditComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    company: selectCompany(ownProps.company_id),
    values: selectNewCompany(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchCompany(ownProps.company_id));
    },
    patch(props, callback) {
      dispatch(updateCompanyProperties(ownProps.company_id, props, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyEdit = compose(withConnect, withRouter)(CompanyEditComp);
